<template lang="pug">

  .ExpandableBox
    .box-content
      .top(
        v-if="title || useTitleSlot"
        :class="{'expandable': expandable}"
        @click="toggleExpand"
      )
        .title(v-if="useTitleSlot")
          slot(name="title")
        .title(v-else) {{ title }}
        .right
          .right-slot
            slot(name="header-right")
          .expand-icon(
            v-if="expandable"
            :class="{'rotate': expanded}"
          )
            IconDownLine
      transition(name="expand")
        .bottom(v-show="expanded")
          slot

</template>

<script>
  export default {
    name: "ExpandableBox",

    props: {
      title: {
        type: String,
      },
      startExpanded: {
        type: Boolean,
        default: false
      },
      expandable: {
        type: Boolean,
        default: true
      },
      useTitleSlot: {
        type: Boolean,
        default: false
      }
    },

    data() {
      return {
        expanded: false
      }
    },

    methods: {

      toggleExpand() {
        this.expanded = !this.expanded
      }

    },

    mounted() {
      if (!this.expandable || this.startExpanded)
        this.expanded = true
    }

  }
</script>

<style lang="scss" scoped>

  .ExpandableBox {

    .box-content {
      padding: 30px;
      background-color: white;
      border-radius: 12px;

      .top {
        display: flex;
        justify-content: space-between;
        align-items: center;
        user-select: none;
        pointer-events: none;
        height: 60px;

        .title {
          font-size: 18px;
          font-weight: bold;
        }

        &.expandable {
          pointer-events: all;
          cursor: pointer;
        }

        .right {
          display: flex;
        }
      }

      .bottom {
        margin-top: 24px;
      }
    }

    .expand-icon {
      color: $color-gray;
      transition: $transition-normal;
      margin-left: 32px;

      &.rotate {
        -webkit-transform: rotate(180deg);
        transform: rotate(180deg);
      }
    }

    .expand-enter-active, .expand-leave-active {
      transition: all $transition-normal ease;
      max-height: 500px;
    }

    .expand-enter, .expand-leave-to {
      opacity: 0;
      max-height: 0;
    }

  }

</style>
s
